import { Game, WINNER } from "./types";
import { SCORE_TYPE } from "./constants";

const getWinnerFromScoreNumbers = (firstScore: number, secondScore: number) =>
  firstScore > secondScore
    ? WINNER.a
    : firstScore === secondScore
      ? WINNER.c
      : WINNER.b;

const getWinnerFromScoreText = (score: string) => {
  const separatedScore = score.split(":").map((score: string) => +score);

  return getWinnerFromScoreNumbers(separatedScore[0], separatedScore[1]);
};

export const getWinner = (
  isMultiNumericScore: boolean,
  isFightingScore: boolean,
  gameScore: string,
  winner?: WINNER,
) => {
  if (isMultiNumericScore) {
    const scoreArray = gameScore
      .split("|")
      .map((score) => score.trim())
      .map((score) => getWinnerFromScoreText(score));

    const firstParticipantWinsCount = scoreArray.filter(
      (gameWinner) => gameWinner === WINNER.a,
    ).length;
    const secondParticipantWinsCount = scoreArray.filter(
      (gameWinner) => gameWinner === WINNER.b,
    ).length;

    return getWinnerFromScoreNumbers(
      firstParticipantWinsCount,
      secondParticipantWinsCount,
    );
  }

  if (isFightingScore) {
    return winner;
  }

  return getWinnerFromScoreText(gameScore);
};

export const getRoleAndLabel = (game: Game) => {
  const {
    gameScore,
    date,
    gameTitleWithScoreText,
    firstParticipant,
    secondParticipant,
    participants,
    winner,
  } = game;

  switch (game.scoreType) {
    case SCORE_TYPE.CRICKET:
    case SCORE_TYPE.VOLLEYBALL:
    case SCORE_TYPE.TWO_TEAM:
      return {
        ariaLabel: `Game score: ${gameScore}, Teams: ${firstParticipant} vs ${secondParticipant}`,
      };
    case SCORE_TYPE.BADMINTON_AND_TABLE_TENNIS:
    case SCORE_TYPE.TENNIS:
      return {
        ariaLabel: `Game score: ${gameScore}, Players: ${firstParticipant} vs ${secondParticipant}`,
      };
    case SCORE_TYPE.WRESTLING:
    case SCORE_TYPE.UFC:
      return {
        ariaLabel: `Game score: ${gameScore}, Fighters: ${firstParticipant} vs ${secondParticipant}, Winner: ${winner}`,
      };
    case SCORE_TYPE.SURFING:
      return {
        ariaLabel: `Game date: ${date}, Participants: ${participants?.join(
          ", ",
        )}`,
      };
    default:
      return {
        ariaLabel: `Game title: ${gameTitleWithScoreText}`,
      };
  }
};
